<script setup>
import { computed, defineEmits } from 'vue';
import 'highlight.js/styles/default.css';
import 'highlight.js/lib/common';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store.js';

import Button from 'next/button/Button.vue';

const props = defineProps({
  result: {
    type: String,
    default: '',
  },
  hasError: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['test']);

const textResult = computed(() => {
  if (typeof props.result === 'object') {
    return JSON.stringify(props.result);
  }

  return props.result;
});

const uiFlags = useMapGetter('wgptBotTools/getUIFlags');

const { t } = useI18n();
</script>

<template>
  <div class="space-y-4">
    <div class="flex items-center justify-between">
      <label
        class="mb-0.5 text-sm font-medium text-n-slate-12 flex flex-col gap-1 relative"
      >
        {{ t('WGPT_BOTS.EDIT.TABS.TOOLS.TEST_TOOL.RESULTS_LABEL') }}
      </label>
    </div>

    <Button
      slate
      sm
      :is-loading="uiFlags.isTesting"
      :disable="uiFlags.isTesting"
      color="blue"
      :label="t('WGPT_BOTS.EDIT.TABS.TOOLS.TEST_TOOL.TEST_BUTTON_LABEL')"
      @click="emit('test')"
    />

    <highlightjs
      v-if="result"
      language="javascript"
      :code="textResult"
      class="[&_code]:text-start min-h-4"
      :class="
        hasError ? '[&_code]:!bg-n-ruby-5/50' : '[&_code]:!bg-n-teal-5/50'
      "
    />
    <p v-else class="px-6 py-10 text-sm leading-6 text-center text-n-slate-11">
      {{ t('WGPT_BOTS.EDIT.TABS.TOOLS.TEST_TOOL.RESULTS_PLACEHOLDER') }}
    </p>
  </div>
</template>
